// extracted by mini-css-extract-plugin
module.exports = {"stepsWrapper":"antd-pro-components-status-steps-styles-stepsWrapper","customStep":"antd-pro-components-status-steps-styles-customStep"};